import NoMoreFromMap from "containers/v2/ListingDiscoveryContainer/NoMoreFromMap";
import useTranslation from "next-translate/useTranslation";
import dynamic from "next/dynamic";
import { PAGE_SIZE } from "pagesHelpers/ListingPagesHepler/SlugTransformation";
import { Suspense, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectors as ListingreducerSelectors } from "redux/slices/v2/ListingReducer";
import { RootState } from "types/RootState";
import ListingCardSqueleton from "../ListingCard/ListingCardSqueleton";
import ListingsListCss from "./ListingsList.module.css";

import { actions as ListingreducerActions } from "redux/slices/v2/ListingReducer";
import AgenzHelperCard from "../AgenzHelperCard";
import ListingsResultAndSort from "../ListingsResultAndSort";
import formatUrl from "utils/FormatUrl";
import DropDownComponent from "../SearchBarComponent/components/SaveSearch/DropDownComponent";
import { titleSuffix } from "utils/BuildUrl/buildTitleAnnonce";
import ViewportOnlyCardComponent from "SanityComponents/LocationAnnoncesLp/AnnoncesCard/ViewportOnlyCardComponent";
import $ from "utils/selectors";
import { set_size } from "utils/getImageToDisplay";
import Head from "next/head";
import { fix_type } from "pagesHelpers/ListingPagesHepler/ListingPagesHelperWrapper";
import { selectors as AuthreducerSelectors } from "../../../../redux/slices/authReducer";
import LinksCard from "../LinksCard";
import getAnnoncesStaticPathsQuartier from "pagesHelpers/AnnoncesStaticPaths/getAnnoncesStaticPathsQuartier.mjs";
import api_call_v2 from "utils/API_CALL/api_call_v2";
import openQuartierVenteList from "pagesHelpers/AnnoncesStaticPaths/openQuartiersVente.mjs";
import { norm } from "../ListingsRouterUrlHelper";
import openQuartierLocationList from "pagesHelpers/AnnoncesStaticPaths/openQuartiersLocation.mjs";
import { pluralOf } from "pagesHelpers/ListingPagesHepler/HeadSeoHelper";
export const handleQuartierListBackend: any = (searchPayload, results) => {
  if (!results.length) {
    return results;
  }
  return searchPayload.transaction_type == "Location"
    ? results.filter((item) => {
        if (
          openQuartierLocationList
            .filter((q) => {
              return q.slug == norm(searchPayload.province);
            })
            .filter((q) => {
              return (
                q.slug == norm(searchPayload.province) &&
                q.type ==
                  `${
                    searchPayload.transaction_type == "Location"
                      ? "location"
                      : "vente"
                  }-${norm(pluralOf(searchPayload.type))}` &&
                norm(q.quartier) == norm(item.quartier) &&
                norm(q.quartier) !== norm(searchPayload.quartier)
              );
            }).length
        ) {
          return item;
        } else {
          return null;
        }
      })
    : results.filter((item) => {
        if (
          openQuartierVenteList
            .filter((q) => {
              return q.slug == norm(searchPayload.province);
            })
            .filter((q) => {
              return (
                q.slug == norm(searchPayload.province) &&
                q.type ==
                  `${
                    searchPayload.transaction_type == "Location"
                      ? "location"
                      : "vente"
                  }-${norm(pluralOf(searchPayload.type))}` &&
                norm(q.quartier) == norm(item.quartier) &&
                ((searchPayload.quartier &&
                  !norm(q.quartier).includes(norm(searchPayload.quartier))) ||
                  !searchPayload.quartier)
              );
            }).length
        ) {
          return item;
        } else {
          return null;
        }
      });
};
export const handleProvinceListBackend: any = (results) => {
  return results;
};
export const shouldWeFetchLink: any = (searchPayload, type = false) => {
  if (!type) {
    if (
      !searchPayload.province &&
      !searchPayload.commune &&
      !searchPayload.prixmin &&
      !searchPayload.prixmax &&
      !searchPayload.surfacemin &&
      !searchPayload.surfacemax &&
      (!searchPayload.typologie ||
        searchPayload.typologie == "[]" ||
        !searchPayload.typologie.length) &&
      (!searchPayload.type ||
        searchPayload.type == "[]" ||
        !searchPayload.type.length) &&
      !searchPayload.exclusivite &&
      !searchPayload.virtual_tour
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    if (
      !searchPayload.province &&
      !searchPayload.commune &&
      !searchPayload.prixmin &&
      !searchPayload.prixmax &&
      !searchPayload.surfacemin &&
      !searchPayload.surfacemax &&
      (!searchPayload.typologie ||
        searchPayload.typologie == "[]" ||
        !searchPayload.typologie.length) &&
      ((searchPayload.type && searchPayload.type !== "[]") ||
        searchPayload.type.length == 1) &&
      !searchPayload.exclusivite &&
      !searchPayload.virtual_tour
    ) {
      return true;
    } else {
      return false;
    }
  }
};
const LoginRegisterDialog = dynamic(
  () => import("components/LoginRegisterDialog"),
  {
    ssr: false,
    suspense: true,
  }
);

type ListingsListComponentProps = {
  hideTitleAndSortAndFavIcon?: boolean;
  listings: RootState["listingsV2"]["listings"];
  favLoading: RootState["listingsV2"]["favListings"];
  favListings: RootState["listingsV2"]["favListings"];
  listingsLoading: boolean;
  listingsRefreching: boolean;
  title?: string;
  totalListingsCount: number;
  h1Type?: any;
  onFavoriteIconPress: (id: string) => void;
  onListingPress: (
    listing: RootState["listingsV2"]["listings"][number]
  ) => void;
  mapVsList?: string;
  listingsSearchPayload?: any;
  isAuthDialogVisible?: any;
  setAuthDialogVisible?: any;
};

export default function ListingsListComponent({
  hideTitleAndSortAndFavIcon = false,
  listings,
  favLoading,
  favListings,
  listingsLoading,
  listingsRefreching,
  title,
  totalListingsCount,
  h1Type,
  onListingPress,
  listingsSearchPayload,
  onFavoriteIconPress,
  mapVsList,
  isAuthDialogVisible,
  setAuthDialogVisible,
}: ListingsListComponentProps) {
  const { t, lang } = useTranslation("commonAnnonces");
  const t2 = useTranslation("villesprovincescommunes").t;

  const searchPayload: any = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );
  const initialSearchPayload: any = useSelector(
    ListingreducerSelectors.initialSearchPayloadSelector
  );
  const userData = useSelector(AuthreducerSelectors.userSelector);

  const userRedux = useSelector((store: any) => store?.auth?.user);

  const handleSignInSuccess: any = () => {
    setAuthDialogVisible(false);
  };
  useEffect(() => {
    dispatch(
      ListingreducerActions.setDisplayMobileSearchBar(!isAuthDialogVisible)
    );
  }, [isAuthDialogVisible]);

  const listingsRefreshing: any = useSelector(
    ListingreducerSelectors.refreshingSelactor
  );

  const dispatch = useDispatch();
  const [alternateAlerteComponent, setAlternateAlerteComponent] = useState(0);
  // const onBottomEndReached = () => {
  //   if (totalListingsCount <= PAGE_SIZE) {
  //     return;
  //   }
  //   if (listingsRefreshing || listingsLoading) {
  //     return;
  //   } else if (totalListingsCount) {
  //     if (
  //       parseInt((totalListingsCount / PAGE_SIZE).toString()) <
  //       searchPayload.page
  //     ) {
  //       return;
  //     } else {
  //       dispatch(ListingreducerActions.increasePage({}));
  //     }
  //   } else if (listings.length === 0) {
  //     return;
  //   } else {
  //     dispatch(ListingreducerActions.increasePage({}));
  //   }
  // };

  // const listInnerRef = useRef();

  // const onScroll = () => {
  //   if (window.innerWidth < 990) {
  //     if ($(window).scrollTop() > 0.5 * $(document).height()) {
  //       onBottomEndReached();
  //     }
  //   } else {
  //     if (
  //       $("#scroll--container").scrollTop() >
  //       0.3 * $("#scroll--container").prop("scrollHeight")
  //     ) {
  //       onBottomEndReached();
  //     }
  //   }
  // };

  // const handleChangeResult = () => {
  //   debounce_custom(onScroll, 150);
  // };

  // const scrollHandler = () => {
  //   handleChangeResult();
  //   if ($(window).scrollTop() > 50) {
  //     $("#filters--container").css("position", "fixed");
  //     $("#filters--container").css("top", "10px");
  //     $("#filters--container").css("background-color", "white");
  //     $("#navbar__mobile__container__annonce").css("display", "none");
  //   } else {
  //     $("#filters--container").css("position", "relative");
  //     $("#filters--container").css("top", "0px");
  //     $("#filters--container").css("background-color", "white");
  //     $("#navbar__mobile__container__annonce").css("display", "block");
  //   }
  // };

  const [pagetitle, setPageTitle] = useState<string>(title);

  const titlePrefix = (
    t,
    transaction_type: "Vente" | "Location" | "Projets Neufs" | "",
    bienType: (
      | "Appartement"
      | "Villa"
      | "Terrain"
      | "Commerce"
      | "Bureau"
      | "Maison"
      | "Villas"
      | "Appartements"
      | "Lots de terrains"
      | "Riad"
      | "Local Industriel"
      | string
    )[],
    vendu:boolean
  ) => {
    switch (transaction_type) {
      case "Vente":
        return bienType.length === 1
          ? `${t(pluralOf(bienType[0]))} ${vendu ? t("vendu") : t("à vendre")}`
          : vendu ? t("Annonces immobilières vendu") : t("Annonces immobilières de vente");
      case "Location":
        return bienType.length === 1
          ? `${t(bienType[0].replace("Local", "Locaux"))} ${t("à louer")}`
          : t("Annonces immobilières de location");

      case "Projets Neufs":
        return t("Annonces de projets neufs");
      default:
        return t("Immobilier et maisons");
    }
  };

  const searchPayloadRef = useRef(searchPayload);
  const firstUpdateTitle = useRef(true);
  const titleComplement: any = useSelector(
    ListingreducerSelectors.titleComplementSelector
  );
  const quartier_links: object[] = useSelector(
    ListingreducerSelectors.quartier_linksSelector
  );
  const [linksQuartier, setLinksQuartier] = useState(quartier_links);

  useEffect(() => {
    searchPayloadRef.current = searchPayload;
    if (firstUpdateTitle.current) {
      firstUpdateTitle.current = false;
      return;
    }
    if (searchPayload.no_trigger_search) {
      return;
    }
    if (searchPayload.province) {
      api_call_v2(
        null,
        "get",
        `annonces/count/${searchPayload.province}?transaction_type=${searchPayload.transaction_type}&type=${searchPayload.type}`,
        null,
        "v3"
      )
        .then((res) => {
          setLinksQuartier(handleQuartierListBackend(searchPayload, res.data));
        })
        .catch((err) => {});
    } else if (shouldWeFetchLink(searchPayload, false)) {
      api_call_v2(
        null,
        "get",
        `annonces/count/transaction/${
          searchPayload.transaction_type == "Location" ? "louer" : "acheter"
        }`,
        null,
        "v3"
      )
        .then((res) => {
          setLinksQuartier(handleProvinceListBackend(res.data));
        })
        .catch((err) => {});
    } else if (shouldWeFetchLink(searchPayload, true)) {
      api_call_v2(
        null,
        "get",
        `annonces/count/type/${norm(searchPayload.type[0])}?transaction_type=${
          searchPayload.transaction_type == "Location" ? "louer" : "acheter"
        }`,
        null,
        "v3"
      )
        .then((res) => {
          setLinksQuartier(handleProvinceListBackend(res.data));
        })
        .catch((err) => {});
    } else {
      setLinksQuartier([]);
    }

    setPageTitle(
      `${titlePrefix(
        t,
        searchPayload?.transaction_type ?? "",
        fix_type(searchPayload),
        searchPayload.vendu ? searchPayload.vendu : false,
      )} ${
        searchPayload.controlBy == "MAP"
          ? ""
          : titleSuffix(
              searchPayload?.region ?? "",
              searchPayload?.province ?? "",
              searchPayload?.address
                ? searchPayload?.address.split(",")[0]
                  ? searchPayload?.address.split(",")[0]
                  : searchPayload?.address
                : searchPayload?.commune ?? "",
              t,
              searchPayload?.quartier ?? [],
              titleComplement ? t(titleComplement) : "",
              searchPayload?.address ?? ""
            )
      }`
    );
  }, [searchPayload]);
  const sortRef = useRef(listingsSearchPayload.sort);
  const listingCountRef = useRef(totalListingsCount);

  // useEffect(() => {
  //   if (window.innerWidth < 990) {
  //     $(window).on("scroll", scrollHandler);
  //     return () => {
  //       $(window).off("scroll", scrollHandler);
  //       return;
  //     };
  //   }
  // }, [
  //   listingsSearchPayload.page,
  //   totalListingsCount,
  //   listingsSearchPayload.sort,
  // ]);
  // useEffect(() => {
  //   if (window.innerWidth < 990) {
  //     setTimeout(() => {
  //       $(window).on("scroll", scrollHandler);
  //     }, 2000);
  //     return () => {
  //       $(window).off("scroll", scrollHandler);
  //       return;
  //     };
  //   }
  // }, [
  //   listingsSearchPayload.page,
  //   totalListingsCount,
  //   listingsSearchPayload.sort,
  // ]);
  return (
    <>
      {/* {  && (
        <Suspense fallback={<></>}>
          <LoginRegisterDialog
            visible={isAuthDialogVisible}
            bodyScrollonClose={true}
            onClose={() => setAuthDialogVisible(false)}
            onFacebookSignInSuccess={handleSignInSuccess}
            onGoogleSignInSuccess={handleSignInSuccess}
            onRegisterSucccess={handleSignInSuccess}
            onSignInSuccess={handleSignInSuccess}
            onSwitchSignType={() => {
              return;
            }}
            Estimation={false}
          />
        </Suspense>
      )} */}

      <>
        {listingsLoading ? (
          <>
            <div className={ListingsListCss.list}>
              {!hideTitleAndSortAndFavIcon && (
                <Suspense fallback={<></>}>
                  <div style={{ width: "100%" }}>
                    <ListingsResultAndSort
                      totalListingsCount={totalListingsCount}
                      map={mapVsList == "MAP"}
                    />
                  </div>
                </Suspense>
              )}
              {[0, 1].map((i) => (
                <div
                  className={
                    mapVsList == "LIST"
                      ? ListingsListCss.listItem
                      : ListingsListCss.listItemMap
                  }
                  key={`loading_${i}`}
                >
                  <ListingCardSqueleton />
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            <div
              style={{ width: "100%" }}
              className={ListingsListCss.resultSort}
            >
              {/* <ListingsPageTitleAndSort
                  title={pagetitle}
                  totalListingsCount={totalListingsCount}
                  h1Type={h1Type}
                /> */}
              <ListingsResultAndSort
                totalListingsCount={totalListingsCount}
                map={mapVsList == "MAP"}
              />
            </div>
            {!searchPayload.vendu && linksQuartier.length > 0 ? (
              <LinksCard
                t={t}
                searchPayload={searchPayload}
                lang={lang}
                linksQuartier={linksQuartier}
              />
            ) : null}
            <div
              className={`${
                mapVsList == "LIST"
                  ? ListingsListCss.listListingCards
                  : ListingsListCss.list
              } scroll-desktop`}
              // style={
              //   mapVsList == "LIST"
              //     ? {
              //         gap: "24px",
              //         justifyContent: "flex-start",
              //         position: "relative",
              //       }
              //     : {
              //         gap: "16px",
              //         justifyContent: "center",
              //         position: "relative",
              //       }
              // }
              style={
                mapVsList == "MAP"
                  ? {
                      gap: "16px",
                      justifyContent: "center",
                      position: "relative",
                    }
                  : {}
              }
              id="scroll--container"
              // onScroll={() => {
              //   debounce_custom(onScroll, 150);
              // }}
            >
              {listingsRefreching ? (
                ((listings || []).length % 2 == 0 ? [0, 1] : [0, 1]).map(
                  (i) => (
                    <div
                      className={
                        mapVsList == "LIST"
                          ? ListingsListCss.listItem
                          : ListingsListCss.listItemMap
                      }
                      key={`refreshing_${i}`}
                    >
                      <ListingCardSqueleton />
                    </div>
                  )
                )
              ) : (
                <>
                  {listings[0] ? (
                    <>
                      <ViewportOnlyCardComponent
                        className={
                          mapVsList == "LIST"
                            ? ListingsListCss.listItem
                            : ListingsListCss.listItemMap
                        }
                        mapVsList={mapVsList}
                        id={"listing_dom"}
                        componentPath={""}
                        priority={true}
                        position={1}
                        key={0}
                        listing={listings[0]}
                        onListingPress={onListingPress}
                        defaultLiked={
                          listings[0]
                            ? favListings.includes(listings[0]._id)
                            : false
                        }
                        searchPayload={searchPayload}
                        initialSeachPayload={initialSearchPayload}
                      />
                    </>
                  ) : null}

                  {(listings.slice(1) || []).map((listing, i) => {
                    if (
                      (searchPayload.page * PAGE_SIZE + (i + 1)) % 8 == 7 &&
                      Math.floor(
                        (searchPayload.page * PAGE_SIZE + (i + 1)) / 8
                      ) %
                        3 ==
                        0
                    ) {
                      return (
                        <>
                          <ViewportOnlyCardComponent
                            className={
                              mapVsList == "LIST"
                                ? ListingsListCss.listItem
                                : ListingsListCss.listItemMap
                            }
                            mapVsList={mapVsList}
                            id={"listing_dom"}
                            componentPath={""}
                            position={i + 1}
                            key={i}
                            priority={i == 0}
                            listing={listing}
                            onListingPress={onListingPress}
                            defaultLiked={favListings.includes(listing._id)}
                            searchPayload={searchPayload}
                            initialSeachPayload={initialSearchPayload}
                          />
                          {i == 3 ? (
                            <div
                              id="listing_dom"
                              style={{ position: "absolute" }}
                            ></div>
                          ) : null}
                          <div
                            className={
                              mapVsList == "LIST"
                                ? ListingsListCss.listItem
                                : ListingsListCss.listItemMap
                            }
                            key={`${i}_bis`}
                            style={{ boxShadow: "none", maxWidth: "none" }}
                          >
                            <AgenzHelperCard
                              mapVsList={mapVsList}
                              icon={
                                <svg
                                  width="22"
                                  height="23"
                                  viewBox="0 0 22 23"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.7493 16.0833H18.3327L17.0448 14.7955C16.6956 14.4462 16.4993 13.9725 16.4993 13.4786V10.5833C16.4993 8.1886 14.9689 6.15133 12.8327 5.3963V5.08333C12.8327 4.07081 12.0119 3.25 10.9993 3.25C9.98683 3.25 9.16602 4.07081 9.16602 5.08333V5.3963C7.02983 6.15133 5.49935 8.1886 5.49935 10.5833V13.4786C5.49935 13.9725 5.30313 14.4462 4.95387 14.7955L3.66602 16.0833H8.24935M13.7493 16.0833V17C13.7493 18.5188 12.5181 19.75 10.9993 19.75C9.48057 19.75 8.24935 18.5188 8.24935 17V16.0833M13.7493 16.0833H8.24935"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              }
                              borderClassName=""
                              title={t("Activez l'alerte")}
                              subtitle={t(
                                "Soyez alerté quand de nouvelles annonces sont disponibles pour votre recherche !"
                              )}
                              buttonAction={() => {
                                if (userRedux?._id) {
                                  setAlternateAlerteComponent(1);
                                } else {
                                  setAuthDialogVisible(true);
                                }
                              }}
                              alternateComponent={
                                alternateAlerteComponent ? (
                                  <DropDownComponent
                                    setDropdownToggles={() => {
                                      setAlternateAlerteComponent(0);
                                    }}
                                    isModal={false}
                                  />
                                ) : null
                              }
                              buttonText={t("Activez l'alerte")}
                            />
                          </div>
                        </>
                      );
                    } else if (
                      (searchPayload.page * PAGE_SIZE + (i + 1)) % 8 == 7 &&
                      Math.floor(
                        (searchPayload.page * PAGE_SIZE + (i + 1)) / 8
                      ) %
                        3 ==
                        1
                    ) {
                      return (
                        <>
                          <ViewportOnlyCardComponent
                            className={
                              mapVsList == "LIST"
                                ? ListingsListCss.listItem
                                : ListingsListCss.listItemMap
                            }
                            mapVsList={mapVsList}
                            id={"listing_dom"}
                            componentPath={""}
                            position={i + 1}
                            key={i}
                            listing={listing}
                            priority={false}
                            onListingPress={onListingPress}
                            defaultLiked={favListings.includes(listing._id)}
                            searchPayload={searchPayload}
                            initialSeachPayload={initialSearchPayload}
                          />
                          {i == 3 ? (
                            <div
                              id="listing_dom"
                              style={{ position: "absolute" }}
                            ></div>
                          ) : null}

                          <div
                            className={
                              mapVsList == "LIST"
                                ? ListingsListCss.listItem
                                : ListingsListCss.listItemMap
                            }
                            key={`${i}_bis`}
                            style={{ boxShadow: "none", maxWidth: "none" }}
                          >
                            <AgenzHelperCard
                              mapVsList={mapVsList}
                              icon={
                                <svg
                                  width="22"
                                  height="22"
                                  viewBox="0 0 22 22"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_9894_3495)">
                                    <path
                                      d="M19.077 4.928C17.191 3.041 14.683 2.001 12.011 2C6.505 2 2.024 6.479 2.022 11.985C2.021 13.745 2.481 15.463 3.355 16.977L2 22L7.233 20.763C8.692 21.559 10.334 21.978 12.006 21.979H12.01C17.515 21.979 21.996 17.499 21.999 11.994C22.001 9.325 20.963 6.816 19.077 4.928ZM16.898 15.554C16.69 16.137 15.671 16.699 15.213 16.74C14.755 16.782 14.326 16.947 12.218 16.116C9.681 15.116 8.079 12.515 7.955 12.349C7.83 12.182 6.936 10.996 6.936 9.768C6.936 8.54 7.581 7.936 7.81 7.687C8.039 7.437 8.309 7.375 8.476 7.375C8.642 7.375 8.809 7.375 8.954 7.381C9.132 7.388 9.329 7.397 9.516 7.812C9.738 8.306 10.223 9.54 10.285 9.665C10.347 9.79 10.389 9.936 10.306 10.102C10.223 10.268 10.181 10.372 10.057 10.518C9.932 10.664 9.795 10.843 9.683 10.955C9.558 11.079 9.428 11.215 9.573 11.464C9.719 11.714 10.219 12.531 10.961 13.192C11.915 14.042 12.718 14.305 12.968 14.431C13.218 14.556 13.363 14.535 13.509 14.368C13.655 14.202 14.133 13.64 14.299 13.39C14.465 13.14 14.632 13.182 14.861 13.265C15.09 13.348 16.317 13.952 16.566 14.077C16.816 14.202 16.982 14.264 17.044 14.368C17.106 14.471 17.106 14.971 16.898 15.554Z"
                                      fill="white"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_9894_3495">
                                      <rect
                                        width="22"
                                        height="22"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              }
                              borderClassName="green"
                              title={t("Besoin d'aide ?")}
                              subtitle={t(
                                "Entrez en relation avec votre conseiller privilégié agenz"
                              )}
                              buttonAction={() => {
                                window.open(
                                  `https://api.whatsapp.com/send?phone=${
                                    // userData
                                    //   ? userData.isPro
                                    //     ? "+212664211141"
                                    //     : searchPayload.transaction_type == "Projets Neufs" ? "+212665250835" : "+212669793808"
                                    searchPayload.transaction_type ==
                                    "Projets Neufs"
                                      ? "+212665250835"
                                      : "+212669793808"
                                  }&text=${t(
                                    searchPayload.exclusivite
                                      ? "Bonjour, J'aimerais avoir plus d'informations concernant les exclusivités Agenz et le partage de commission"
                                      : "Bonjour, J'ai un projet immobilier et je souhaiterai être accompagné"
                                  )}%0a`
                                );
                              }}
                              buttonText={t("Contacter")}
                            />
                          </div>
                        </>
                      );
                    } else if (
                      (searchPayload.page * PAGE_SIZE + (i + 1)) % 8 == 7 &&
                      Math.floor(
                        (searchPayload.page * PAGE_SIZE + (i + 1)) / 8
                      ) %
                        3 ==
                        2 &&
                      !searchPayload.exclusivite
                    ) {
                      return (
                        <>
                          <div
                            className={
                              mapVsList == "LIST"
                                ? ListingsListCss.listItem
                                : ListingsListCss.listItemMap
                            }
                            key={`${i}_bis`}
                            style={{ boxShadow: "none", maxWidth: "none" }}
                          >
                            <AgenzHelperCard
                              mapVsList={mapVsList}
                              icon={
                                <svg
                                  width="23"
                                  height="22"
                                  viewBox="0 0 23 22"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M19.75 19.25L14.25 13.75M16.0833 9.16667C16.0833 12.7105 13.2105 15.5833 9.66667 15.5833C6.12284 15.5833 3.25 12.7105 3.25 9.16667C3.25 5.62284 6.12284 2.75 9.66667 2.75C13.2105 2.75 16.0833 5.62284 16.0833 9.16667Z"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              }
                              borderClassName=""
                              title={t("Vous vendez d’abord ?")}
                              subtitle={t(
                                "Estimez votre bien gratuitement et en deux minutes sur agenz"
                              )}
                              buttonAction={() => {
                                window.open(formatUrl("/estimation/map", lang));
                              }}
                              buttonText={t("Estimer")}
                            />
                          </div>

                          <ViewportOnlyCardComponent
                            className={
                              mapVsList == "LIST"
                                ? ListingsListCss.listItem
                                : ListingsListCss.listItemMap
                            }
                            mapVsList={mapVsList}
                            id={"listing_dom"}
                            componentPath={""}
                            position={i + 1}
                            key={i}
                            priority={i == 0}
                            listing={listing}
                            onListingPress={onListingPress}
                            defaultLiked={favListings.includes(listing._id)}
                            searchPayload={searchPayload}
                            initialSeachPayload={initialSearchPayload}
                          />
                          {i == 3 ? (
                            <div
                              id="listing_dom"
                              style={{ position: "absolute" }}
                            ></div>
                          ) : null}
                        </>
                      );
                    } else {
                      return (
                        <>
                          <ViewportOnlyCardComponent
                            className={
                              mapVsList == "LIST"
                                ? ListingsListCss.listItem
                                : ListingsListCss.listItemMap
                            }
                            mapVsList={mapVsList}
                            id={"listing_dom"}
                            position={i + 1}
                            componentPath={""}
                            key={i}
                            priority={i == 0}
                            listing={listing}
                            onListingPress={onListingPress}
                            defaultLiked={favListings.includes(listing._id)}
                            fromLp={false}
                            searchPayload={searchPayload}
                            initialSeachPayload={initialSearchPayload}
                          />
                          {i == 3 ? (
                            <div
                              id="listing_dom"
                              style={{ position: "absolute" }}
                            ></div>
                          ) : null}
                        </>
                      );
                    }
                  })}
                </>
              )}
              {/* <ListingCard
                            liked={favListings.includes(listing._id)}
                            listing={listing}
                            loadingLike={favLoading.includes(listing._id)}
                            onFavoriteIconPress={onFavoriteIconPress}
                            onListingPress={onListingPress}
                            hideFavIcon={hideTitleAndSortAndFavIcon}
                            a__href={encodeURI(listing.url)}
                          /> */}
              <div id="bottom" style={{ position: "absolute" }}></div>

              {Math.floor(totalListingsCount / PAGE_SIZE) ==
                searchPayload.page && !listingsLoading ? (
                <NoMoreFromMap mapVsList={mapVsList} />
              ) : null}
            </div>
            {!listingsLoading &&
              !listingsRefreching &&
              (listings || []).length === 0 && (
                <p className={ListingsListCss.NoListingFound}>
                  {t("Aucune annonce ne correspond à vos critères")}
                </p>
              )}
          </>
        )}
      </>
    </>
  );
}
